import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

export const getUrlFromSlug = (slug: string, baseUrl?: string, languageRegionCode?: LanguageRegionCode) =>
  languageRegionCode ? `${baseUrl || ''}${wrapUrlSafe(slug, languageRegionCode)}` : `${baseUrl || ''}/${slug}`;

export const getActivityUrl = (slug: string, baseUrl?: string, languageRegionCode?: LanguageRegionCode) => {
  const activitySlug = `/explore/recording/${slug}`;
  return languageRegionCode ? `${baseUrl || ''}${wrapUrlSafe(activitySlug, languageRegionCode)}` : `${baseUrl || ''}${activitySlug}`;
};

export const getMapUrl = (slug: string, baseUrl?: string, languageRegionCode?: LanguageRegionCode) => {
  const mapSlug = `/explore/map/${slug}`;
  return languageRegionCode ? `${baseUrl || ''}${wrapUrlSafe(mapSlug, languageRegionCode)}` : `${baseUrl || ''}${mapSlug}`;
};

export const getCustomRouteUrl = (slug: string, baseUrl?: string, languageRegionCode?: LanguageRegionCode) => {
  const customRouteSlug = `/explore/custom-routes/${slug}`;
  return languageRegionCode ? `${baseUrl || ''}${wrapUrlSafe(customRouteSlug, languageRegionCode)}` : `${baseUrl || ''}${customRouteSlug}`;
};

export const getTrailUrl = (slug: string, baseUrl?: string, languageRegionCode?: LanguageRegionCode) => {
  const trailSlug = `/trail/${slug}`;
  return languageRegionCode ? `${baseUrl || ''}${wrapUrlSafe(trailSlug, languageRegionCode)}` : `${baseUrl || ''}${trailSlug}`;
};

export const getExploreTrailUrl = (slug: string, baseUrl?: string, languageRegionCode?: LanguageRegionCode) => {
  const trailSlug = `/explore/trail/${slug}`;
  return languageRegionCode ? `${baseUrl || ''}${wrapUrlSafe(trailSlug, languageRegionCode)}` : `${baseUrl || ''}${trailSlug}`;
};

export const getListUrl = (slug: string, baseUrl?: string, languageRegionCode?: LanguageRegionCode) => {
  const listSlug = `/lists/${slug}`;
  return languageRegionCode ? `${baseUrl || ''}${wrapUrlSafe(listSlug, languageRegionCode)}` : `${baseUrl || ''}${listSlug}`;
};
